import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import CorrectIcon from '@common/images/correct-relative.svg';
import IncorrectIcon from '@common/images/incorrect-relative.svg';
import style from './style.module.scss';

const MESSAGE_TYPE = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
};

const MESSGAES = {
  [MESSAGE_TYPE.COMPLETE]: {
    message: 'You have selected all the correct options.',
    icon: CorrectIcon,
    className: style.complete,
  },
  [MESSAGE_TYPE.INCOMPLETE]: {
    message: "You haven't selected all the correct options.",
    icon: IncorrectIcon,
    className: style.incomplete,
  },
};

/**
 *  MultiSelectFeedback:
 *  - Component checks answerIds and checkboxes in MultiSelect Quetion
 *     and determine the feedback to display.
 *  - The component gives a feeedback message for Multiple Ansswer questions
 *  - A success message is displayed when all right answers are selected
 *  - A failure message is displayed when there are still correct answers to be selected.
 */

export function MultiSelectFeedback(props) {
  let messageType = MESSAGE_TYPE.INCOMPLETE;

  const allSubmittedOptions = props.checkboxes.reduce((list, checkbox) => {
    if (checkbox.disabled) list.push(checkbox.id);
    return list;
  }, []);

  const isAllAnswersSumitted = props.answerId.every((answer) =>
    allSubmittedOptions.includes(answer)
  );

  if (allSubmittedOptions.length) {
    if (isAllAnswersSumitted) messageType = MESSAGE_TYPE.COMPLETE;
    return (
      <div
        tabIndex={props.tabIndex}
        className={`${props.className} ${style.messagefeedback} ${MESSGAES[messageType].className}`}>
        <Image src={MESSGAES[messageType].icon} alt={messageType} />
        <span>{MESSGAES[messageType].message}</span>
      </div>
    );
  } else {
    return null;
  }
}

MultiSelectFeedback.propTypes = {
  /**
   * The className to be set for the componnet
   */
  className: PropTypes.string.isRequired,
  /**
   * The list of ID's for the correct Options
   */
  answerId: PropTypes.arrayOf(PropTypes.number).isRequired,
  /**
   * The list of options.
   */
  checkboxes: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.string,
};

MultiSelectFeedback.defaultProps = {className: ''};
